import React, { useState } from "react";
import { Text, Box, UnstyledButton, TextInput, Group, ActionIcon } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { restrictToVerticalAxis, restrictToParentElement } from '@dnd-kit/modifiers';

import FilterOptionSortableItem from "./FilterOptionSortableItem";

import { generateUniqueName, generateKeyFromName, reorderOptions } from "../../../../utils/Filters";

export default function FilterOptions({ options = [], onUpdateOption }) {
  const [isAdding, setIsAdding] = useState(false);
  const [newOption, setNewOption] = useState("");

  const handleAddOption = () => {
    if (newOption.trim()) {
      onUpdateOption(newOption.trim());
      setNewOption("");
    }
  };

  const handleRemoveOption = (id) => {
    const newArray = options.filter((item) => item.id !== id);
    onUpdateOption(newArray);
  };

  return (
    <>
      <Group spacing={0} position="apart">
        <Text size="xs" weight={500} mb={6} pl={10} color="grey">Options</Text>
        {!!options.length && (
          <ActionIcon onClick={() => setIsAdding(!isAdding)}>
            <FontAwesomeIcon icon={isAdding ? solid("minus") : solid("plus")} size="xs" color="grey" />
          </ActionIcon>
        )}
      </Group>
      <Box mb="xs">
        {isAdding ? (
          <TextInput
            size="xs"
            mx={10}
            placeholder="Type a new option..."
            value={newOption}
            onChange={(e) => setNewOption(e.currentTarget.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleAddOption()}
          />
        ) : options.length === 0 ? (
          <UnstyledButton
            style={{ display: "flex", alignItems: "center" }}
            mx={10}
            onClick={() => setIsAdding(true)}
          >
            <FontAwesomeIcon icon={solid("plus")} size="xs" />
            <Text size="xs" pl={10}>Add an option</Text>
          </UnstyledButton>
        ) : null}
        <Box mt={4}>
          <DndContext
            modifiers={[restrictToVerticalAxis, restrictToParentElement]}
            onDragEnd={({ active, over }) => {
              if (active.id !== over?.id) {
                const oldIndex = options.findIndex((i) => i.id === active.id);
                const newIndex = options.findIndex((i) => i.id === over?.id);
                const updatedItems = reorderOptions(options, oldIndex, newIndex);
                onUpdateOption(updatedItems, true);
              }
            }}
            collisionDetection={closestCenter}
          >
            <SortableContext items={options.map((i) => i.id)} strategy={verticalListSortingStrategy}>
              {options.map((option, index) => (
                <FilterOptionSortableItem
                  key={option.key}
                  id={option.id}
                  name={option.name}
                  color={option.color}
                  onEdit={(value, color) => {
                    const option_name = value !== option.name ? generateUniqueName(value, options) : option.name;
                    const option_key = generateKeyFromName(option_name);
                    const color_value = color ? { color } : {};
                    const updatedItems = options.map((item) => {
                      if (item.id === option.id) {
                        return { ...item, ...color_value, name: option_name, id: option_key, value: option_key };
                      }
                      return item;
                    });
                    onUpdateOption(updatedItems);
                  }}
                  onDelete={() => handleRemoveOption(option.id)}
                />
              ))}
            </SortableContext>
          </DndContext>
        </Box>
      </Box>
    </>
  );
}